// "whatwg-fetch": "^2.0.4"
import 'whatwg-fetch';
// "promise-polyfill": "^8.1.0",
// import 'promise-polyfill';
import 'promise-polyfill/lib/polyfill';

export default class InitVideoPlayer {
	constructor() {
		const videoElement = document.getElementById('featureArea__video') as HTMLVideoElement;
		if (videoElement) {
			const videoId = videoElement.getAttribute('data-id');
			if (videoId) {
				const addSourcesOnVideo = (src: string, type: string) => {
					const sourceEl = document.createElement('source');
					sourceEl.src = src;
					sourceEl.type = type;
					videoElement.appendChild(sourceEl);
				};
				fetch(`https://api.gfycat.com/v1/gfycats/${videoId}`)
					.then((response) => {
						if (response.status >= 200 && response.status < 300) {
							return response;
						} else {
							const err = new Error(response.statusText);
							throw err;
						}
					})
					.then(response => response.json())
					.then(json => {
						if (json.gfyItem.webmUrl) {
							addSourcesOnVideo(json.gfyItem.webmUrl, 'video/webm');
						}
						if (json.gfyItem.mp4Url) {
							addSourcesOnVideo(json.gfyItem.mp4Url, 'video/mp4');
						}
						videoElement.play();
					})
					.catch(err => { console.error(err); });
			}
		}
	}
}